import { render, staticRenderFns } from "./card-payouts.vue?vue&type=template&id=0a4c27b3&scoped=true&"
import script from "./card-payouts.vue?vue&type=script&lang=js&"
export * from "./card-payouts.vue?vue&type=script&lang=js&"
import style0 from "./card-payouts.vue?vue&type=style&index=0&id=0a4c27b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4c27b3",
  null
  
)

export default component.exports